import React from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled, FileExcelOutlined } from "@ant-design/icons";
import SpecTabsView from "./SpecTabsView";

// Review-before-upload: shows the parsed spec and a Confirm button that
// performs the actual upload (passed in as onConfirm).
function SpecReviewModal({ open, meta, parsed, onConfirm, onCancel, confirming }) {
  return (
    <Modal
      open={open}
      onCancel={confirming ? undefined : onCancel}
      width="82vw"
      style={{ top: 24 }}
      maskClosable={false}
      destroyOnClose
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <FileExcelOutlined style={{ color: "#185FA5" }} />
          <span style={{ fontWeight: 600 }}>Review control document</span>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              background: "#EAF3DE",
              color: "#3B6D11",
              padding: "1px 10px",
              borderRadius: 20,
              fontSize: 12,
              fontWeight: 500,
            }}
          >
            <CheckCircleFilled /> Validation passed
          </span>
        </div>
      }
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={confirming}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" loading={confirming} onClick={onConfirm}>
          Confirm &amp; Upload
        </Button>,
      ]}
    >
      <div
        style={{
          display: "flex",
          gap: 18,
          flexWrap: "wrap",
          fontSize: 13,
          color: "#6B7280",
          marginBottom: 12,
        }}
      >
        <span>
          <b style={{ color: "#111827" }}>Name:</b> {meta?.specName || "—"}
        </span>
        <span>
          <b style={{ color: "#111827" }}>File:</b> {meta?.fileName || "—"}
        </span>
      </div>
      {parsed && (
        <SpecTabsView
          fileLevel={parsed.fileLevel}
          columnLevel={parsed.columnLevel}
          allowableValues={parsed.allowableValues}
        />
      )}
    </Modal>
  );
}

export default SpecReviewModal;
